import { Image, ScrollView, View } from "react-native";
import Svg, { Path } from "react-native-svg";
import { getUserDetails, updateUserProfile } from "appRedux/reducers/profileSlice";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useRef, useState } from "react";

import Buttons from "components/Buttons";
import Input from "components/Input";
import ParentScrollView from "components/ParentScrollView";
import VText from "components/VText";
import { router } from "expo-router";
import useImageHandler from "hooks/useImageHandler";

const CreateProfile = () => {
    const [name, setName] = useState();
    const [gender, setGender] = useState();
    const [loading, setLoading] = useState(false);

    const profileData = useSelector((state) => state.ProfileReducer.profileData);
    const userId = useSelector((state) => state.AuthReducer.userId);

    const { imageUri, onImagePress, setImageUri } = useImageHandler(null, false, "Images");

    const dispatch = useDispatch();

    useEffect(() => {
        if (profileData && Object.keys(profileData)?.length) {
            setName(profileData?.name);
            setGender(profileData?.gender);
            setImageUri(profileData?.profilePicUrl);
        }
    }, [profileData]);

    const onCreate = () => {
        setLoading(true);
        dispatch(
            updateUserProfile({
                emailId: profileData?.emailId,
                name: name?.toLowerCase()?.trim(),
                gender: gender?.toLowerCase(),
                isImageUpated: imageUri?.includes("http") ? false : true,
                base64ImgString: imageUri?.includes("http") ? null : imageUri,
                userId: userId,
            })
        )
            .then((res) => {
                if ([200].includes(res?.payload?.data?.data?.statusCode)) {
                    dispatch(getUserDetails())
                        .then((res) => {
                            setLoading(false);
                            router.navigate(`${gender == "men" ? "/men" : ""}/`);
                        })
                        .catch((err) => {
                            setLoading(false);
                            console.log("err", err);
                            alert("Error");
                        });
                } else {
                    setLoading(false);
                    alert("Error");
                }
            })
            .catch((err) => {
                setLoading(false);
                console.log("err", err);
                alert("Error");
            });
    };

    return (
        <ParentScrollView>
            <View
                style={{
                    alignItems: "center",
                    paddingTop: 80,
                    paddingBottom: 120,
                    flex: 1,
                    backgroundColor: "white",
                }}
            >
                <VText
                    text="Create Profile"
                    style={{
                        fontSize: 40,
                    }}
                />
                <View
                    style={{
                        backgroundColor: "#F7F7F7",
                        padding: 40,
                        marginTop: 52,
                    }}
                >
                    <VText
                        text="Would you like to upload your picture?"
                        style={{
                            fontSize: 20,
                            lineHeight: 28,
                            fontWeight: "bold",
                            paddingBottom: 28,
                        }}
                    />
                    {!imageUri && (
                        <Svg
                            width="100"
                            height="100"
                            viewBox="0 0 100 100"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <Path
                                d="M50 58.915C38.2427 58.915 28.6826 49.354 28.6826 37.5976C28.6826 25.8403 38.2429 16.2793 50 16.2793C61.7571 16.2793 71.3174 25.8403 71.3174 37.5967C71.3174 49.354 61.7571 58.915 50 58.915ZM50 21.4473C41.085 21.4473 33.8501 28.6822 33.8501 37.5971C33.8501 46.5121 41.085 53.747 50 53.747C58.9149 53.747 66.1499 46.5121 66.1499 37.5971C66.1499 28.6831 58.9149 21.4473 50 21.4473V21.4473Z"
                                fill="#DBDBDB"
                            />
                            <Path
                                d="M50 100C22.4806 100 0 77.6488 0 50C0 22.3512 22.4802 0 50 0C77.5198 0 100 22.4802 100 50C100 77.5198 77.5198 100 50 100ZM50 5.16796C25.323 5.16796 5.16796 25.3228 5.16796 50C5.16796 74.6772 25.3228 94.832 50 94.832C74.6772 94.832 94.832 74.6772 94.832 50C94.832 25.3228 74.6772 5.16796 50 5.16796V5.16796Z"
                                fill="#DBDBDB"
                            />
                            <Path
                                d="M18.6044 84.8843L14.3408 82.0419C22.222 70.0269 35.6582 62.791 49.9997 62.791C64.2121 62.791 77.5191 69.8972 85.4002 81.6545L81.1367 84.4969C74.1604 74.1608 62.5318 67.9594 49.9997 67.9594C37.3385 67.9594 25.5811 74.2904 18.6044 84.8843V84.8843Z"
                                fill="#DBDBDB"
                            />
                        </Svg>
                    )}

                    {imageUri && (
                        <Image
                            source={{ uri: imageUri }}
                            style={{
                                height: 100,
                                width: 100,
                                borderRadius: 100,
                            }}
                        />
                    )}

                    <Buttons
                        containerStyle={{
                            borderRadius: 0,
                            marginTop: 28,
                            padding: 16,
                            backgroundColor: "transparent",
                            alignSelf: "flex-start",
                            minWidth: 120,
                            borderWidth: 1,
                        }}
                        noBorder={false}
                        isInverse
                        onPress={onImagePress}
                        text={"Upload"}
                    />
                    <VText
                        text="What’s your name?"
                        style={{
                            fontSize: 20,
                            lineHeight: 28,
                            fontWeight: "bold",
                            paddingBottom: 28,
                            marginTop: 48,
                        }}
                    />
                    <Input
                        placeholder="Name"
                        value={name}
                        onChangeText={(txt) => {
                            setName(txt.replace(/^\s+/, "").replace(/\d+/g, ""));
                        }}
                        containerStyle={{}}
                    />
                    <VText
                        text="You can change this later in your profile settings"
                        style={{
                            fontSize: 20,
                            lineHeight: 20,
                            paddingBottom: 48,
                            marginTop: 20,
                            color: "rgba(33, 36, 39, 0.6)",
                        }}
                    />
                    <VText
                        text="What’s your gender?"
                        style={{
                            fontSize: 20,
                            lineHeight: 28,
                            fontWeight: "bold",
                            paddingBottom: 28,
                        }}
                    />
                    <View
                        style={{
                            flexDirection: "row",
                            alignItems: "center",
                        }}
                    >
                        {["Male", "Female", "Others"].map((item, idx) => (
                            <Buttons
                                key={idx}
                                containerStyle={{
                                    borderColor:
                                        item?.toLowerCase() == gender?.toLowerCase()
                                            ? "rgba(33, 36, 39, 1)"
                                            : "rgba(0, 0, 0, 0.16)",
                                    backgroundColor: "transparent",
                                    width: 120,
                                    marginRight: 16,
                                    padding: 16,
                                    borderWidth: item?.toLowerCase() == gender?.toLowerCase() ? 2 : 1,
                                }}
                                textStyle={{
                                    color: "#212427",
                                }}
                                onPress={() => setGender(item)}
                                isInverse={item?.toLowerCase() == gender?.toLowerCase() ? false : true}
                                text={item}
                            />
                        ))}
                    </View>
                    <VText
                        text={`Feeds will be prioritized based on your selected\ngender. You can change this later in profile\nsettings`}
                        style={{
                            fontSize: 20,
                            lineHeight: 24,
                            paddingBottom: 48,
                            marginTop: 20,
                            color: "rgba(33, 36, 39, 0.6)",
                        }}
                    />
                    <Buttons
                        containerStyle={{
                            width: 120,
                            marginRight: 16,
                            padding: 16,
                            flex: 1,
                            width: "100%",
                            opacity: gender && name?.length > 3 ? 1 : 0.6,
                        }}
                        loading={loading}
                        disabled={gender && name?.length > 3 ? false : true}
                        onPress={onCreate}
                        text={"Create"}
                    />
                </View>
            </View>
        </ParentScrollView>
    );
};

export default CreateProfile;
